import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getServicesDetailList = createAsyncThunk(
  "servicesDetailList/getServicesDetailList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/service/get_all_data`,

        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        data
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const servicesDetailSlice = createSlice({
  name: "servicesDetailList",
  initialState: {
    loading: false,
    servicesDetailData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getServicesDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getServicesDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.servicesDetailData = action.payload;
      })
      .addCase(getServicesDetailList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default servicesDetailSlice.reducer;
